<template>
  <div class="mini-box tw-fixed tw-bottom-0 tw-right-0 tw-bg-white  tw-z-10 overflow-hidden tw-mr-5"
       :class="[{'expanded': expanded}]">
    <div class="tw-py-4 tw-px-6  tw-flex tw-justify-center tw-items-center tw-cursor-pointer" @click="toggleExpand">
      <i class="tw-mr-5 tw-pt-1 far fa-comments"></i>
      <p class="tw-text-black tw-text-lg tw-mr-2 tw-font-semibold">{{ translations['messages.your_inbox'] }}</p>
      <div class="unread-length tw-rounded-full tw-w-2 tw-h-2 tw-bg-red-500 tw-flex tw-justify-center tw-items-center"
           v-if="getIncomingMessage">
        <!-- <span v-text="activeInboxCount"></span> -->
      </div>
      <div class="tw-ml-auto toggle-btn" :class="[{'expanded': expanded}]">
        <i class="far fa-chevron-up"></i>
      </div>
    </div>
    <div class="list" :class="[{'expanded': expanded}]">
      <div v-if="showList">
        <div class="tw-px-6 ">
          <input type="text"
                 id="search-box"
                 class="tw-border-none tw-w-full tw-text-base tw-px-4"
                 :placeholder="translations['messages.search_for']"
                 v-model="searchQuery"
          />
        </div>
        <div id="item-list">
          <thread-list
              v-if="searchQuery.length < 2 && !showAllUsers"
              @item-click="goToThread"
          ></thread-list>
          <search-list
              v-if="searchQuery.length >= 2 || showAllUsers"
              :searchQuery="searchQuery"
              @item-click="openNewThread"
              @set-active-thread="goToThread"
              :showAllUsers="showAllUsers"
          ></search-list>
        </div>
      </div>
      <div class="tw-flex tw-py-4 tw-px-6">
        <a class="tw-py-3 tw-w-full tw-text-center tw-font-semibold tw-rounded tw-bg-gray-100 hover:tw-bg-gray-200 focus:tw-bg-gray-200  tw-text-black tw-mr-4"
           href="/messages">{{ translations['messages.all_chats'] }}</a>
        <button type="button"
                class="tw-py-3 tw-w-full tw-text-center tw-font-semibold tw-rounded tw-bg-blue-500 hover:tw-bg-blue-600 focus:tw-bg-blue-600 tw-text-white tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
                @click="showAllUsers = !showAllUsers">
          <i class="far tw-text-white tw-pt-1 tw-mr-2"
             :class="[{'fa-times':showAllUsers}, {'fa-comment-plus': !showAllUsers}]"></i>
          <span>{{ showAllUsers ? translations['fields.close'] : translations['messages.start_new_chat'] }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ThreadList from '../../../components/messenger/ThreadList';
import SearchList from '../../../components/messenger/SearchList';
import NotificationCentre from '../../../mixins/NotificationCentre';
import Global from '../../../mixins/Global.js';

export default {
  name: 'MiniBox',
  data() {
    return {
      expanded: false,
      searchQuery: '',
      showUnreadIndicator: false,
      showAllUsers: false,
      showList: false
    };
  },

  mixins: [Global, NotificationCentre],
  components: {
    'thread-list': ThreadList,
    'search-list': SearchList,
  },
  methods: {
    toggleExpand() {
      if (this.expanded === true) {
        this.expanded = false;

        if (typeof showListTimer !== 'undefined') {
          clearTimeout(showListTimer);
        }

        let showListTimer = setTimeout(() => {
          this.showList = false;
        }, 550);
      } else {
        this.expanded = true;
        this.showList = true;
      }
      this.incomingMessage = false;
    },
    goToThread(id) {
      window.location = `/messages?thread_id=${id}`;
    },
    openNewThread(id, threadId) {
      if (threadId) {
        this.goToThread(threadId);
      } else {
        window.location = `/messages?participant_id=${id}`;
      }
    },

    listenForIncoming() {
      if (this.privateChannel) {
        return;
      }

      window.Echo.private(`messages.${self.user.id}`)
          .listen('.inbox', async (message) => {
            const _message = { ...message.message };
            if (_message.user_id !== self.user.id) {
              // when incomingMessage is an object, you can add the threadId as a key, and true as a value to count the threads unread
              // but, we don't have the thread id's from the backend, only number of unread threads. so this wont work (yet)
              // this.$set(this.incomingMessage, threadId, true)
              this.incomingMessage = true;

            }
          });
    },
  },
  mounted() {
    this.listenForIncoming();
  }
};
</script>

<style lang="scss">
.mini-box {
  width: 400px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 5px 5px 0px 0px;

  #search-box {
    font-family: Open Sans !important;
    padding: 14px;
    min-height: 48px;
    color: #696969;
    width: 100%;
    outline: none !important;
    border-radius: 5px;
    background: #f0f0f1;
  }


  #item-list, #results, #thread-list {
    max-height: calc(50vh - 90px - 25px);
    //height:auto;
    overflow-y: scroll;
  }

  .unread-length {
    width: 10px;
    height: 10px;
    color: white;
    font-size: 11px;
    font-weight: bold;
  }

  .list {
    max-height: 0;
    transition: all .5s ease-in-out;

    &.expanded {
      max-height: calc(50vh);
      height: auto;
    }
  }


  .toggle-btn {
    transform: rotate(0deg);
    transition: transform .5s ease;

    &.expanded {
      transform: rotate(180deg);
    }
  }
}
</style>
